import { Injectable, signal } from '@angular/core'

export interface GlobalModalConfig {
  title: string
  description: string
  confirmButtonLabel: string
  cancelButtonLabel: string
  onConfirm: () => void
  onCancel?: () => void
}

@Injectable({ providedIn: 'root' })
export class GlobalModalService {
  readonly config = signal<GlobalModalConfig | null>(null)

  show(config: GlobalModalConfig): void {
    this.config.set(config)
  }

  hide(): void {
    this.config.set(null)
  }
}
